import { render } from "./Images.vue?vue&type=template&id=4480193c&scoped=true"
import script from "./Images.vue?vue&type=script&lang=js"
export * from "./Images.vue?vue&type=script&lang=js"

import "./Images.vue?vue&type=style&index=0&id=4480193c&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4480193c"]])

export default __exports__